<template>
  <div class="hotel_container">
    <Loading :loading="wholeLoading" />
    <div class="hotel_container_panel">
      <Carousel :adsType="adsType"></Carousel>
      <result-search
        :searchInfo="searchInfo"
        @fromSearch="getcityInfo"
        @hotelInfo="hotelInfo"
        @locationInfo="locationInfo"
        :pageCount="pageCount"
        :keywordInput="keywordInput"
        :PositionCityCode="positionCityCode"
        @clearPositionCityCode="positionCityCode = ''"
      ></result-search>
      <el-breadcrumb separator-class="el-icon-arrow-right" style="height: 5rem; line-height: 5rem">
        <el-breadcrumb-item :to="{ name: 'Home', query: this.$store.state.pathQuery }">{{$t("RESULT.SEARCHHOTEL")}}</el-breadcrumb-item>
        <el-breadcrumb-item>{{ $t("MAPRESULT.MAPPAGE") }}</el-breadcrumb-item>
      </el-breadcrumb>
      <el-row class="location_area_bg">
        <el-col :xs="3" :sm="3" :md="3" :lg="3" :xl="3">
          <div class="grid-content">
            <span class="fontstyle" style="color: #979da2">{{$t("RESULT.LOCATION")}}</span>
          </div>
        </el-col>
        <el-col :xs="21" :sm="21" :md="21" :lg="21" :xl="21">
          <div class="grid-content">
            <!-- tab area"  -->
            <el-tabs element-loading-background="rgba(151.157162,0.8)" v-model="activeName" @tab-click="locationAdd" class="homeMain deleteBorder">
              <el-tab-pane v-if="objBaseInfo.destinationType=='D'" :label="$t('RESULT.DISTRICT')" name="first" :class="{ tag_height: isActive }">
                <template v-for="item in locationInformation">
                  <el-tag v-if="item.locationNameLists[$t('RESULT.RESPONSEDATA.locationNameLists')]" class="icon_tags" disable-transitions @click="addChosentags(item,true)" type="info" :key="item.locationCode" effect="plain">
                    {{ item.locationNameLists[$t("RESULT.RESPONSEDATA.locationNameLists")] }}
                  </el-tag>
                </template>
              </el-tab-pane>
              <el-tab-pane v-if="haveAirports" :label="$t('RESULT.AIRORTRAIWAY')" name="second" :class="{ tag_height: isActive }">
                <template v-for="name in airportslocationInfo">
                  <el-tag v-if="name.locationNameLists[$t('RESULT.RESPONSEDATA.locationNameLists')]" disable-transitions @click="addChosentags(name,true)" class="icon_tags" type="info" :key="name.value" effect="plain">
                    {{ name.locationNameLists[$t("RESULT.RESPONSEDATA.locationNameLists")] }}
                  </el-tag>
                </template>
              </el-tab-pane>
              <el-tab-pane v-if="haveCustoms" :label="$t('RESULT.CUSTOM')" name="third" :class="{ tag_height: isActive }">
                <template v-for="custom in customlocationInfo">
                  <el-tag v-if="custom.locationNameLists[$t('RESULT.RESPONSEDATA.locationNameLists')]" disable-transitions @click="addChosentags(custom,true)" class="icon_tags" type="info" :key="custom.value" effect="plain">
                    {{ custom.locationNameLists[$t("RESULT.RESPONSEDATA.locationNameLists")] }}
                  </el-tag>
                </template>
              </el-tab-pane>
              <div style="cursor: pointer; font-size: 2rem" @click="expand()">
                <i class="el-icon-caret-bottom" v-show="showArrow" aria-hidden="true"></i>
                <i class="el-icon-caret-top" v-show="showArrowDown" aria-hidden="true"></i>
              </div>
            </el-tabs>
          </div>
        </el-col>
      </el-row>
      <el-row class="location_area_bg" v-if="showHotHotel">
        <el-col :xs="3" :sm="3" :md="3" :lg="3" :xl="3">
          <div class="grid-content">
            <span class="fontstyle" style="color: #979da2">{{$t("RESULT.HOTHOTEL")}}</span>
          </div>
        </el-col>
        <el-col :xs="21" :sm="21" :md="21" :lg="21" :xl="21">
          <div class="grid-content">
            <!-- tab area"  -->
            <el-tabs element-loading-background="rgba(151.157162,0.8)" v-model="activeName" class="homeMain deleteBorder">
              <template v-for="item in hotHotelInfo">
                <el-tag v-if="item.hotelName[$t('RESULT.RESPONSEDATA.locationNameLists')]" class="icon_tags" disable-transitions @click="choseHotHotel(item)" type="info" :key="item.hotelCode" effect="plain">
                  {{ item.hotelName[$t("RESULT.RESPONSEDATA.locationNameLists")] }}
                </el-tag>
              </template>
            </el-tabs>
          </div>
        </el-col>
      </el-row>
      <div class="div_search_result" style="margin-top: 1.3rem">
        <span class="fontstyle">{{ $t("RESULT.TOTAL") }} {{ this.totalNum }}</span>
        <span class="fontstyle" style="margin-left: 0.5rem">{{$t("RESULT.HOTELSFOUND")}}</span>
        <el-tag disable-transitions @close="handleClose(tag)" class="fontstyle tag_sty" v-for="tag in chosentags" :key="tag.name" closable type="info">
          {{ tag[$t("RESULT.RESPONSEDATA.locationNameLists")] }}
        </el-tag>
      </div>
      <div class="div_select_bar">
        <div class="grid-content center_style" style="padding-left: 2rem;">
          <span class="commen_font" @click="ptOpenDowOrUp('price')">{{$t("RESULT.PRICE")}}</span>
          <el-icon v-if="show ==3" class="red_color" title="Minus"><Minus /></el-icon>
          <el-icon v-if="show ==1" class="red_color" title="Ascending"><SortUp /></el-icon>
          <el-icon v-if="show ==2" class="red_color" title="Descending"><SortDown /></el-icon>
        </div>
        <div class="grid-content center_style">
          <el-select class="payment" v-model="priceAreaValue" :placeholder="$t('RESULT.PRICERANGE')">
            <el-option v-for="item in priceRangeOptions" :key="item.value" :label="item.label[$t('COMMONPARAM.RESPONSEDATA.SHOWTYPE')]" :value="item.value" @click="handlePriceRangeChange(item.value)">
            </el-option>
          </el-select>
        </div>
        <div class="grid-content center_style">
          <span class="commen_font" @click="ptOpenDowOrUp('star')">{{$t("RESULT.STARRATING")}}</span>
          <el-icon v-if="showstar ==3" class="red_color" title="Minus"><Minus /></el-icon>
          <el-icon v-if="showstar ==1" class="red_color" title="Ascending"><SortUp /></el-icon>
          <el-icon v-if="showstar ==2" class="red_color" title="Descending"><SortDown /></el-icon>
        </div>
        <div class="grid-content center_style">
          <el-select class="payment" v-model="stars" :placeholder="computedPlaceholder" clearable multiple @visible-change ="handleStarChange" @clear="getHotelData" @remove-tag="getHotelData">
            <el-option v-for="item in this.starOption" :key="item.value" :label="item.text" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="grid-content center_style">
          <el-select class="payment" v-model="groupCode" :placeholder="$t('BOOKING.HOTELGROUP')" clearable filterable  @change ="getHotelData" @clear="getHotelData">
            <el-option v-for="item in this.hotelGroupOption" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="grid-content center_style">
          <el-select class="payment" v-model="paymentType" :placeholder="$t('RESULT.PAYMENT')" clearable @change="getHotelData">
            <el-option v-for="item in this.getPaymentOption" :key="item.value" :label="item.text" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="grid-content center_style">
          <div class="grid-content center_style">
            <el-select class="payment" v-model="radiusValue" :placeholder="$t('RESULT.DISTANCE')" @change="getHotelData">
              <el-option v-for="item in disOptions" :key="item.value" :label="item.label[$t('COMMONPARAM.RESPONSEDATA.SHOWTYPE')]" :value="item.value">
              </el-option>
            </el-select>
          </div>
        </div>
        <div class="div_select_loc">
          <div style="float: left">
            <svg-icon iconClass="ic_menu" class="menuIcon"></svg-icon>
          </div>
          <div class="main_link_tab link_location" @click="GoResult">{{ $t("MAPRESULT.SHOWONLIST") }}</div>
        </div>
      </div>
      <div class="div_result">
        <div class="div_result_l">
          <div class="leftPart" ref="mainBox">
            <div class="div_result_imgs" v-for="(item, index) in this.hotelList" :key="-index">
              <div class="div_result_img_f" :id="'nodePage' + item.hotelDescriptiveInfo.id" @mouseenter="handleOver(item, 'ONE')" @mouseleave="handleOut(item)">
                <div class="div_result_bg" :style="{backgroundColor: item.tagShow ? '#EEFFBB' : 'white',}"></div>
                <!-- :class="resultList ? 'tab_active':'tab_default '" -->
                <div class="float_hotel_info" @click="GoDetail(item)">
                  <el-row>
                    <el-col :span="14">
                      <div class="hotel_title">{{item.hotelDescriptiveInfo.name[$t("RESULT.RESPONSEDATA.name")]}}</div>
                        <div :span="0.1" v-if="item.hotelDescriptiveInfo.standardStar > 0" style="display: flex; align-items: center;">
                        <el-rate v-model="item.hotelDescriptiveInfo.standardStar" disabled class="my-rate-reform" :colors="['#F2A900', '#F2A900', '#F2A900']"></el-rate>
                        <div class="hotel_midfont" v-if="item.emission && item.emission.score >= 45" style="margin-left: 1rem;">
                          <div style="display: flex; align-items: center;">
                            <span style="margin-right: -.3rem;color: #E7E9EA;">{{ separator }}</span>
                            <svg-icon icon-class="emission" style="height: 17px;vertical-align: -0.4em;"></svg-icon>
                            <span style="color: #222A30; font-family: 'Source Sans Pro'; vertical-align: middle; display: inline-block;">{{ $t("RESULT.EMISSION")}}</span>
                          </div>
                        </div>
                      </div>
                      <div :span="0.1" v-else style="display: flex; align-items: center;">
                        <span v-for="n in item.hotelDescriptiveInfo.starRating" :key="n">
                          <svg-icon icon-class="hotel_icon_diamond" style="height: 15px;width:20px;"></svg-icon>
                        </span>
                        <div class="hotel_midfont" v-if="item.emission && item.emission.score >= 45">
                          <div style="display: flex; align-items: center;">
                            <span style="margin-right: -.3rem;color: #E7E9EA;">{{ separator }}</span>
                            <svg-icon icon-class="emission" style="height: 17px;vertical-align: -0.4em;"></svg-icon>
                            <span style="color: #222A30; font-family: 'Source Sans Pro'; vertical-align: middle; display: inline-block;">{{ $t("RESULT.EMISSION")}}</span>
                          </div>
                        </div>
                      </div>
                      <div style="margin-top: 1rem">
                        <div class="address_info ellipsis-2-lines">{{item.hotelDescriptiveInfo.address[$t("RESULT.RESPONSEDATA.address")]}}</div>
                        <div class="address_info">{{ item.hotelDescriptiveInfo.contactNumber }}</div>
                        <div v-if="objBaseInfo.sourceType == 'CRM'" class="address_info">FXId:{{ item.hotelDescriptiveInfo.id }}</div>
                        <div style="margin-top: 1rem;align-items: center;display: flex;">
                          <div class="pricePolicy" v-if="getHotelMarking(item.hotelDescriptiveInfo)!=''">{{getHotelMarking(item.hotelDescriptiveInfo)}}</div>
                          <div class="pricePolicy" v-if="item.isAgencyPreferredHotel &&!item.isClientPreferredHotel">{{ $t("RESULT.CWTHOTEL") }}</div>
                          <div class="pricePolicy" v-if="item.isClientPreferredHotel">{{ getCpHotelMark(item) }}</div>
                          <div class="pricePolicy" v-if="item.isCorpPayHotel">{{ hotelListFacility(item) }}</div>
                          <div class="pricePolicy" v-if="getNotRecommendedShow(item.hotelDescriptiveInfo.group)">{{getNotRecommendedText()}}</div>
                        </div>
                      </div>
                    </el-col>
                    <el-col :span="10">
                      <div style="margin-top: 1rem">
                        <template v-if="objBaseInfo.showTravelTitle && objBaseInfo.displayTravelRules">
                        <div v-if="item.isOutOfPolicy === false && objBaseInfo.hotelBookingRole == 1" style="float: right; margin-right: 4rem">
                          <div class="policy_outof_in policy_in_color">{{ $t("MESSAGE.INPOLICY") }}</div>
                        </div>
                        <div v-if="item.isOutOfPolicy === true"  style="float: right; margin-right: 4rem">
                          <el-tooltip placement="bottom" effect="light" :disabled="!objBaseInfo.policySwitch">
                            <template #content>
                              <div v-for="(d, i) in arrayToObj(
                                item.outOfPoliyDescriptions,
                                item.posHotelTravelRuleDescFlag,
                                item.posHotelTravelRuleDescCn,
                                item.posHotelTravelRuleDescEn,
                                item.currencyCode? $currencySign[item.currencyCode]: $objBaseInfo.defaultCurrencySign
                              )" :key="i" v-html="d"></div>
                            </template>
                            <div class="policy_outof_in policy_outof_color" v-if="objBaseInfo.hotelBookingRole == 1">
                              {{ $t("MESSAGE.OUTOFPOLICY") }}
                            </div>
                          </el-tooltip>
                        </div>
                        <div v-if="item.isOutOfPolicy !== false &&item.isOutOfPolicy !== true" style="float: right; margin-right: 4rem">
                          <div class="policy_outof_in"></div>
                        </div>
                      </template>
                        <div class="priceBottom">
                          <span :data-content-before="pricePrefixSuffix" :data-content-after="pricePrefixSuffix" class="price">
                            {{(item.currencyCode? $currencySign[item.currencyCode]: $objBaseInfo.defaultCurrencySign) +item.averagePrice}}
                          </span>
                        </div>
                      </div>
                    </el-col>
                  </el-row>
                </div>
              </div>
            </div>
            <div v-if="noMore" class="noMore">{{ $t("RESULT.NOMORE") }}</div>
          </div>
        </div>
        <!-- begin map -->
        <div class="div_result_r" style="position: relative;">
          <div id="container" class="map_area"></div>
          <div class="input-card map-search-card" style='width:28rem;'>
            <el-input :placeholder="$t('SEARCH.ADDRESSSEARCH')" v-model="address">
              <template #prefix>
                <svg-icon icon-class="search" class-name="hotel_input__icon el-icon-search" @click="geoCode"></svg-icon>
              </template>
            </el-input>
          </div>
        </div>
        <!-- end map -->
      </div>
    </div>
    <ConfirmBoxs
      :centerDialogVisible="confirmFlag"
      :confirmMsg="confirmMsg"
      :icon="confirmIcon"
      @setConfirmFlag="setConfirmFlag"
    ></ConfirmBoxs>
    <el-dialog v-model="showCustomizePriceRange" width="35rem" center :title="$t('RESULT.PRICERANGE')" customClass="customWidth" :close-on-click-modal="false">
      <div class="form">
        <el-row type="flex" justify="center" align="middle">
          <el-col :xs="12" :lg="6">
            <el-input size="small" v-model="priceRangeFrom" @input="clearNoNumPriceRangeFrom()"></el-input>
          </el-col>
          <el-col :xs="12" :lg="2" style="text-align: center;" >
            <el-icon><Minus /></el-icon>
          </el-col>
          <el-col :xs="12" :lg="6">
            <el-input size="small" v-model="priceRangeTo" @input="clearNoNumPriceRangeTo()" ></el-input>
          </el-col>
        </el-row>
      </div>
      <template #footer>
        <span class="dialog-footer">
          <button class="s_btn btn_dialog" @click="searchHotelForPriceRange()">{{ $t("MESSAGE.CONFIRMBUTTONTEXT") }}</button>
          <button class="dialog_btn_n btn_dialog" @click="showCustomizePriceRange = false">{{ $t("MESSAGE.CONFIRMCANCELTEXT") }}</button>
        </span>
      </template>
    </el-dialog>
    <EjectAnnouncement :centerDialogVisible="hotelListNoticeDialogVisible" @setAnnouncementFlag="setAnnouncementFlag"></EjectAnnouncement>
  </div>
</template>
<script>
import { getCurrentInstance } from 'vue';
import ResultSearch from "../../components/ResultSearch.vue";
import { formatDateTime, hideElement, isCityGAT,getCityInfoByGaoDeCode} from "@/utils/utils";
import Loading from "@/components/Loading.vue";
import ConfirmBoxs from "../../components/confirmBoxs.vue";
import { availabilityProperty,getAnnouncementInfo,getcountryList  } from "@/api/shoppingData.js";
import { locationList, availabilityArea } from "@/api/shoppingData";
import EjectAnnouncement from "../../components/EjectAnnouncement.vue";
import { gethothotel } from "@/api/bookingData.js";
import Carousel from "../../components/Carousel.vue";
import { Minus, SortUp, SortDown } from '@element-plus/icons-vue'
import { showToast } from "vant";
export default {
  name: "gaodeMap",
  components: {
    ResultSearch,
    Loading,
    ConfirmBoxs,
    EjectAnnouncement,
    Carousel,
    Minus,
    SortUp,
    SortDown
  },
  data() {
    return {
      mapLanguage:"",
      disabledRequest: false, // 表示是否执行回调函数触底事件
      tagPosition: null,
      info: [],
      positions: [],
      ContentMaps: "",
      handOpen: null,
      pointArr: [],
      pageCount: 3,
      noMore: false,
      confirmFlag: false,
      confirmIcon: "",
      confirmMsg: "",
      mapDisplay: true,
      tagShow: false,
      resultList: true,
      wholeLoading: true,
      perPage: 30,
      pageNo: 1,
      show: 3,
      showstar: 3,
      ContentCh: "",
      ContentEn: "",
      ContentMap: "",
      starContent: "",
      chooseCode: "",
      checkIn: "",
      checkOut: "",
      roomCount: "",
      guestCount: "",
      marketpoint: null,
      testContent: null,
      locationArr: [],
      cityInfo: "",
      showprice: true,
      hotelList: [],
      searchInfo: JSON.parse(this.$route.query.searchParam),
      map: null,
      infoWindow: null,
      mapList: [],
      roomNum: 1,
      guestNum: 1,
      sortByPrice: null,
      sortByStarRating: null,
      isScrollInit: true,
      totalNum: 0,
      keywordType: "",
      keywordInput: {},
      showArrow: false,
      showArrowDown: false,
      tabName: "",
      isActive: false,
      activeName: "first",
      locationInformation: [],
      airportslocationInfo: [],
      customlocationInfo: [],
      scrollHeight: 0,
      tagHeight: 0,
      haveAirports: false,
      haveCustoms: false,
      chosentags: [],
      labelLongitude: '', //经度
      labelLatitude: '', //经度
      locationCode: "",
      paymentType: "",
      coordinates: {},
      hotelListNoticeDialogVisible: false,
      hotHotelInfo: [],
      showHotHotel: false,
      isCityChange: false,
      adsType: 3,
      isCorpPay: false,
      isHotelPay: false,
      isPrepay:false,
      priceArea:"",
      stars: "",
      originalStarSelect:"",
      groupCode:"",
      radiusValue:"",
      priceAreaValue:"",
      priceRangeOptions:[
        {value: 1,label: { "zh-CN": "不限", en: "unlimited" },},
        {value: 2,label: { "zh-CN": "0-300", en: "0-300" },},
        {value: 3,label: { "zh-CN": "300-500", en: "300-500" },},
        {value: 4,label: { "zh-CN": "500-1000", en: "500-1000" },},
        {value: 5,label: { "zh-CN": "1000以上", en: "From 1000" },},
        {value: 6,label: { "zh-CN": "自定义", en: "customize" },},
      ],
      showCustomizePriceRange: false,
      priceRangeFrom: "",
      priceRangeTo: "",
      starOption:[],
      groupCode:"",
      hotelGroupOption:[],
      disOptions: [
        {value: 1,label: { "zh-CN": "1公里", en: "1KM" },},
        {value: 3,label: { "zh-CN": "3公里", en: "3KM" },},
        {value: 5,label: { "zh-CN": "5公里", en: "5KM" },},
        {value: 10,label: { "zh-CN": "10公里", en: "10KM" },},
        {value: 30,label: { "zh-CN": "30公里", en: "30KM" },},
        {value: 50,label: { "zh-CN": "50公里", en: "50KM" },},
        {value: 100,label: { "zh-CN": "100公里", en: "100KM" },},
      ],
      objBaseInfo:{},
      geocoder: null,
      address: '',
      geolocation:{},
      positionCityCode: "",
      isMapInit: false,
    };
  },
  computed: {
    pricePrefixSuffix: function () {
      return this.$t("DETAIL.ABOVE");
    },
    //获取酒店打标
    getHotelMarking(){
      return (hotel) => {
        if (hotel?.cwtMark) {
          const mark = hotel.cwtMark[this.$i18n.locale] || hotel.cwtMark["zh-CN"] || "";
          return mark;
        }
        return "";
      };
    },
    hotelListFacility() {
      let $this = this;
      return function (hotel) {
        var corpPayHotelName = ""
        if(hotel.isCorpPayHotel){
          if($this.isCorpPay && $this.isPrepay){
            corpPayHotelName = $this.$t("COMMONPARAM.PAYMENTTYPE.PAYMENTTYPE3") + "|" + $this.$t("COMMONPARAM.PAYMENTTYPE.PAYMENTTYPE2");
          }else if($this.isCorpPay){
            corpPayHotelName = $this.$t("COMMONPARAM.PAYMENTTYPE.PAYMENTTYPE3");
          }else if($this.isPrepay){
            corpPayHotelName = $this.$t("COMMONPARAM.PAYMENTTYPE.PAYMENTTYPE2");
          }
        }
        return corpPayHotelName;
      };
    },
    getCpHotelMark(){
      return function(item) {
        if(!item.isFixedCPHotel){
          if(this.objBaseInfo.isShowChainWide){
            return this.$t("RESULT.CHAIMWIDE");
          }
          return "";
        }
        return this.$t("RESULT.CONTRACTEDHOTEL");
      };
    },
    // 顶部下拉菜单 支付方式
    getPaymentOption() {
      var paymentType = [];
      if (this.isCorpPay) {
        paymentType.push({ value: "1", text: this.$t("COMMONPARAM.PAYMENTTYPE.PAYMENTTYPE3")});}
      if(this.isHotelPay){
        paymentType.push({ value: "0", text: this.$t("COMMONPARAM.PAYMENTTYPE.PAYMENTTYPE1")});
      }
      if(this.isPrepay){
        paymentType.push({ value: "2", text: this.$t("COMMONPARAM.PAYMENTTYPE.PAYMENTTYPE2")});
      }
      return paymentType;
    },
    // 星级筛选
    getStarSelect() {
      return [
        { text: this.$t("RESULT.STAR1"), value: "1" },
        { text: this.$t("RESULT.STAR2"), value: "2" },
        { text: this.$t("RESULT.STAR3"), value: "3" },
        { text: this.$t("RESULT.STAR4"), value: "4" },
        { text: this.$t("RESULT.STAR5"), value: "5" },
      ];
    },
    computedPlaceholder() {
      return this.stars != "" ? '' : this.$t('RESULT.STARSELECT');
    },
    getHotelGroupSelect(){
      return [
        { label: this.$t("HOTELGROUPINFO.Hyatt"), value: "12733" },
        { label: this.$t("HOTELGROUPINFO.Wyndham"), value: "12796" },
        { label: this.$t("HOTELGROUPINFO.Radisson"), value: "12766" },
        { label: this.$t("HOTELGROUPINFO.Marriott"), value: "12736" },
        { label: this.$t("HOTELGROUPINFO.Accor"), value: "12725" },
        { label: this.$t("HOTELGROUPINFO.Hilton"), value: "12737" },
        { label: this.$t("HOTELGROUPINFO.IHG"), value: "12738" },
        { label: this.$t("HOTELGROUPINFO.ShangriLa"), value: "12734" },
        { label: this.$t("HOTELGROUPINFO.Rosewood"), value: "12995" },
        { label: this.$t("HOTELGROUPINFO.Millennium"), value: "12781" },
        { label: this.$t("HOTELGROUPINFO.HUAZHU"), value: "12997" },
        { label: this.$t("HOTELGROUPINFO.Ramada"), value: "12772" },
        { label: this.$t("HOTELGROUPINFO.TheRitzCarlton"), value: "12774" },
        { label: this.$t("HOTELGROUPINFO.Raffles"), value: "12727" },
        { label: this.$t("HOTELGROUPINFO.Atour"), value: "12987" },
        { label: this.$t("HOTELGROUPINFO.JinJiangInternational"), value: "12730" },
        { label: this.$t("HOTELGROUPINFO.JinjiangChina"), value: "12976" },
        { label: this.$t("HOTELGROUPINFO.Wanda"), value: "12900" },
        { label: this.$t("HOTELGROUPINFO.Preferred"), value: "13456" },
        { label: this.$t("HOTELGROUPINFO.Ascott"), value: "12759" },
        { label: this.$t("HOTELGROUPINFO.Kempinski"), value: "12768" },
        { label: this.$t("HOTELGROUPINFO.Homeinns"), value: "12755" },
        { label: this.$t("HOTELGROUPINFO.Dossen"), value: "12815" },
        { label: this.$t("HOTELGROUPINFO.DossenInternational"), value: "13388" },
        { label: this.$t("HOTELGROUPINFO.Banyantree"), value: "12810" },
        { label: this.$t("HOTELGROUPINFO.Fraser"), value: "12960" },
        { label: this.$t("HOTELGROUPINFO.Jumeirah"), value: "13024" },
        { label: this.$t("HOTELGROUPINFO.Langham"), value: "12842" },
        { label: this.$t("HOTELGROUPINFO.MandarinOriental"), value: "12926" },
        { label: this.$t("HOTELGROUPINFO.MarcoPolo"), value: "12741" },
        { label: this.$t("HOTELGROUPINFO.NewCentury"), value: "12760" },
        { label: this.$t("HOTELGROUPINFO.SSAW"), value: "13317" }
      ];
    },
    separator() {
      return "| ";
    }
  },
  updated() {
    this.mapContent = this.setMapContent;
    this.setPriceAffix();
    this.starOption = this.getStarSelect;
    this.hotelGroupOption = this.getHotelGroupSelect;
  },
  created() {
    const instance = getCurrentInstance();
    if (instance) {
      this.objBaseInfo = instance.appContext.config.globalProperties.$objBaseInfo || {};
      this.activeName = this.objBaseInfo.destinationType == "D" ? "first" : "second";
      this.adsType = this.objBaseInfo.destinationType == "D" ? 3 : 4;
    }
  },
  mounted() {
    //判断来源 CRM跳转过来隐藏部分元素
    hideElement(this);
    this.roomNum = this.searchInfo.roomCount;
    this.guestNum = this.searchInfo.guestCount;
    this.setPriceAffix();
    let mainBox = this.$refs.mainBox;
    mainBox.addEventListener("scroll", this.onHandleScroll, true);
    if(this.objBaseInfo.sourceType == "OBT"){
      this.popUpAnnouncement();
      this.searchHotHotel();
    }
  },
  watch: {
    "$i18n.locale"() {
      this.initMap();
    },
    //手动触发滚动条事件
    isScrollInit(newValue) {
      if (newValue) {
        var evt = window.document.createEvent("UIEvents");
        evt.initUIEvent("scroll", true, false, window, 0);
        let mainBox = this.$refs.mainBox;
        mainBox.dispatchEvent(evt);
      }
    },
  },
  methods: {
    geoCode(type) {
      this.isMapInit = true;
      const self = this;
      if(this.geocoder){
        const timer = setTimeout(() =>this.handleAddressNotFound(type), 500);
        this.geocoder.getLocation(this.address, function(status, result) {
          clearTimeout(timer);
          if (status === 'complete'&& result.geocodes.length) {
            var lnglat = result.geocodes[0].location;
            self.labelLongitude = lnglat.lng;
            self.labelLatitude = lnglat.lat;
            self.radiusValue = 5;
            self.pageNo = 0;
            self.tabName = "four";
            if (self.$refs.mainBox) {
              self.$refs.mainBox.scrollTop = 0;
            }
            self.getHotelData("geoCode");
          }else{
            console.log("地理编码失败，状态码：" , status);
          }
        });
      }
    },
    handleAddressNotFound(type){
      if(type == "onLocationComplete"){
        this.confirmFlag = true;
        this.confirmMsg = this.$t("SEARCH.NOTMATCH");
      }else{
        this.confirmFlag = true;
        this.confirmMsg = this.$t("SEARCH.ADDRESSNOTFOUND");
      }
    },
    //是否隐藏不推荐
    getNotRecommendedShow(groupid){
      let flag=false;
      if(this.objBaseInfo.hasOwnProperty("notRecommendedModel")){
        let notRecommendedModel=this.objBaseInfo.notRecommendedModel;
        if(notRecommendedModel!=undefined && notRecommendedModel!=null){
          let arrGroupid=notRecommendedModel.notRecommendedGorupid.split(',');
          if (arrGroupid.indexOf(groupid.toString())>=0){
            flag=true;
          }
        }
      }
      return flag;
    },
    getNotRecommendedText(){
      let text="";
      if(this.objBaseInfo.hasOwnProperty("notRecommendedModel")){
        let notRecommendedModel=this.objBaseInfo.notRecommendedModel;
        if(notRecommendedModel!=undefined && notRecommendedModel!=null){
          if (this.$i18n.locale == "en"){
            text=notRecommendedModel.notRecommendedEN;
          }else{
            text=notRecommendedModel.notRecommendedCN;
          }
        }
      }
      return text;
    },
    handleOver(list, type) {
      this.isScrollInit = true;
      let marker = [];
      marker = new AMap.Marker({
        position: [
          list.hotelDescriptiveInfo.location[1].longitude,
          list.hotelDescriptiveInfo.location[1].latitude,
        ],
      });
      marker.extraData = list;
      this.map.add(marker);
      marker.on("mouseover", this.openInfo);
      marker.on("mouseout", this.closeInfo);
      //marker.on("click", this.GoDetail);
      if (type == "ALL") {
        list.tagShow = false;
      } else {
        list.tagShow = true;
      }
      this.mapWinodwInfo(list);
      this.$forceUpdate();
    },
    handleOut(list) {
      list.tagShow = false;
      this.$forceUpdate();
    },
    setConfirmFlag(value) {
      this.confirmFlag = value;
    },
    ptOpenDowOrUp: function (type) {
      this.pageNo = 1;
      this.wholeLoading = true;
      switch (type) {
        case "price":
          if (this.show == 3) {
            this.show = 1;
          } else if (this.show == 1) {
            this.show = 2;
          } else if (this.show == 2) {
            this.show = 1;
          }
          this.showstar = 3;
          this.sortByStarRating = null;
          // this.sortByPrice初始值null
          this.sortByPrice = !this.sortByPrice;
          break;
        case "star":
          if (this.showstar == 3) {
            this.showstar = 1;
          } else if (this.showstar == 1) {
            this.showstar = 2;
          } else if (this.showstar == 2) {
            this.showstar = 1;
          }
          this.show = 3;
          // this.sortByPrice初始值null
          this.sortByPrice = null;
          this.sortByStarRating = !this.sortByStarRating;
          break;
      }
      this.hotelList = [];
      this.totalNum = 0;
      this.getHotelData();
    },
    hotelInfo(value) {
      this.pageNo = 1;
      //接收home页跳转来的参数
      this.disabledRequest = true;
      this.noMore =
        (this.hotelList ? this.hotelList.length : 0) == this.totalNum
          ? true
          : false;
      this.disabledRequest = !this.noMore;
      this.roomNum = this.searchInfo.roomCount;
      this.guestNum = this.searchInfo.guestCount;
      this.keyword = this.searchInfo.keyword;

      this.hotelList = value;
      this.locationArr = [];
      if (this.hotelList && this.hotelList.length > 0) {
        this.hotelList.map((list) => {
          let hotelLocation = list.hotelDescriptiveInfo;
          let latitude = hotelLocation.location[1].latitude;
          let longitude = hotelLocation.location[1].longitude;
          let locationObj = { latitude, longitude };
          this.locationArr.push(locationObj);
          return list;
        });
        this.initMap();
      } else {
        this.initEmpty();
        // this.confirmFlag = true;
        this.noMore = true;
        // this.confirmMsg = this.$t("RESULT.NOMOREWARNING");
      }
      this.wholeLoading = false;
    },
    getcityInfo(value) {
      this.isMapInit = false;
      this.checkpaymentType(value.city.cityInfo);
      this.keywordType = value.keywordType;
      this.disabledRequest = false;
      this.wholeLoading = true;
      this.roomNum = value.roomNum;
      this.guestNum = value.guestNum;
      this.cityInfo = value.cityInfo;
      this.searchInfo.city = value.city;
      this.checkInDate = value.checkInDate;
      this.checkOutDate = value.checkOutDate;
      this.keyword = value.keyword;
      // 搜索 功能后，重新清空hotelList
      this.hotelList = [];
      this.noMore = false;
      this.confirmFlag = false;
      this.mapDisplay = true;
      this.showstar = 3;
      this.show = 3;
      this.sortByPrice = null;
      this.sortByStarRating = null;
      this.isCityChange = value.isCityChange;
      this.locationCode = value.city.cityInfo.locationCode;
      if (!this.keyword && value.city && value.city.cityInfo && value.city.cityInfo.locationType != 0) {
        this.keywordInput = {keyword: value.city.cityInfo.locationName[this.$t("RESULT.RESPONSEDATA.locationNameLists")], keywordType: "auto"};
      }
      // 防止刷新出现无country
      if (value.city.cityInfo) {
        this.objBaseInfo.countryCode = value.city.cityInfo.countryCode;
        this.objBaseInfo.isGATCity = isCityGAT(value.city.cityInfo.provinceCode);
        this.objBaseInfo.provinceCode = value.city.cityInfo.provinceCode;
      }
      this.updateSearchData();
      if (value.city.cityInfo.locationType != 0) {
          let locationInfo = {
            locationNameLists: value.city.cityInfo.locationName,
            longitude: value.city.cityInfo.locationLongitude,
            latitude: value.city.cityInfo.locationLatitude,
            geoCodeType: value.city.cityInfo.locationGeoCodeType,
            locationCode: value.city.cityInfo.locationCode,
          };
          switch (value.city.cityInfo.locationType) {
            case 1:
              this.clearHandle(false, "first", locationInfo);
              break;
            case 2:
              this.clearHandle(false, "second", locationInfo);
              break;
            case 3:
              this.clearHandle(false, "third", locationInfo);
              break;
            case 4:
              this.clearHandle(false, "four", locationInfo);
              break;
          }
        } else {
          if (this.objBaseInfo.channelId == "WEB") {
            this.clearHandle(true, this.activeName, {});
          } else {
            this.clearHandle(true, "first", {});
          }
        }
      //this.getHotelData();
    },
    /**
     * @param {string} [queryType] - rolling:滚动查询;button:搜索按钮查询;不传参:其他查询
     */
    async getHotelData(queryType) {
      if(!this.isMapInit){
        this.address = '';
      }
      if (queryType !== "rolling") {
        this.pageNo = 1;
        this.wholeLoading = true;
        if(this.objBaseInfo.sourceType == "OBT" && queryType !== "geoCode"){
          this.popUpAnnouncement();
          this.searchHotHotel();
        }
      } else {
        this.pageNo = this.pageNo + 1;
        this.wholeLoading = true;
      }
      this.cwtCityCode = this.cityInfo
        ? this.cityInfo
        : this.searchInfo.city.cityCode;
      this.InDay = this.checkInDate
        ? this.checkInDate
        : this.searchInfo.checkInAt;
      this.checkInDay = this.InDay.replaceAll("/", "-");
      this.OutDay = this.checkOutDate
        ? this.checkOutDate
        : this.searchInfo.checkOutAt;
      this.checkOutDay = this.OutDay.replaceAll("/", "-");
      this.radius = this.radiusValue ? this.radiusValue : 1;
      let params = {
        posCode: this.objBaseInfo.poscode,
        customerCode: this.objBaseInfo.customerCode,
        bookingContactId: this.objBaseInfo.loginID, //联系人ID
        countryCode: this.objBaseInfo.countryCode, //国家ID
        cwtCityCode: this.cwtCityCode, //"310100"
        //cwtLocationCode: this.locationCode,
        radius: this.radius,
        radiusUnit: this.radius ? "km" : null,
        checkInDate: formatDateTime(this.checkInDay, "YYYY-MM-DD"),
        checkOutDate: formatDateTime(this.checkOutDay, "YYYY-MM-DD"),
        noGuests: this.guestNum,
        noRooms: this.roomNum,
        sources: [],
        keyword: this.keyword,
        SortByStarRating: this.sortByStarRating,
        SortByPrice: this.sortByPrice,
        pageRequest: {
          page: this.pageNo,
          per_page: this.perPage,
        },
        Language: ["en-US", "zh-CN"],
        PriceArea:this.priceArea,
        stars: this.stars,
        groupCode:this.groupCode,
      };
       if (this.tabName == "first" || this.tabName == "") {
        params.cwtLocationCode = this.locationCode;
        delete params.radius;
        delete params.radiusUnit;
      } else {
        this.coordinates.longitude = this.labelLongitude;
        this.coordinates.latitude = this.labelLatitude;
        this.coordinates.geoType = this.geoCodeType;
        params["coordinates"] = this.coordinates;
      }
      //payment change
      if (this.paymentType !== "") {
        params.paymentMethod = this.paymentType;
      } else {
        delete params.paymentMethod;
      }
      if (this.chosentags.length == 0  && this.tabName != "four" && queryType !== "geoCode") {
        delete params["coordinates"];
        delete params.cwtLocationCode;
        delete params.radius;
        delete params.radiusUnit;
      }
      if (this.objBaseInfo.destinationType == "I" && this.radiusValue) {
        params.radius = this.radiusValue;
        params.radiusUnit = "km";
      }
      if(Object.prototype.hasOwnProperty.call(this.objBaseInfo,"openResource"))
      {
        if(this.objBaseInfo.openResource!=undefined && this.objBaseInfo.openResource!="" && this.objBaseInfo.openResource!=null)
        {
          params.openResource=JSON.parse(this.objBaseInfo.openResource);
        }
      }
      let $this = this;
      availabilityArea(params)
        .then((res) => {
          if (res.code == 200) {
            let currentNum = res.data.hotelList ? res.data.hotelList.length : 0;
            $this.wholeLoading = false;
            if (res.data.error.code != 0) {
              if (queryType !== "rolling") {
                $this.mapDisplay = false;
                $this.noMore = true;
                $this.totalNum = 0;
                $this.confirmFlag = true;
                $this.confirmMsg =
                  $this.$t("ERRORMESSAGE." + res.data.error.code) ===
                  "ERRORMESSAGE." + res.data.error.code
                    ? $this.$t("ERRORMESSAGE.NOTFOUND")
                    : $this.$t("ERRORMESSAGE." + res.data.error.code);
                console.log(
                  "获取房型下拉框数据 请求失败, code:" , res.data.error.code,
                  res.data.error.message
                );
                this.initEmpty();
                $this.hotelList = [];
              } else {
                //处理接口bug，本该有数据返回但接口返回空的情况
                if (currentNum === 0) {
                  $this.pageNo = $this.pageNo - 1;
                  $this.noMore = false;
                  $this.hotelList = [];
                }
              }
              console.log(
                "availabilityArea, code:" , res.data.error.code,
                res.data.error.message
              );
            } else {
              $this.totalNum = res.data.pagination.totalItemCount
                ? res.data.pagination.totalItemCount
                : 0;
              if (queryType !== "rolling") {
                $this.hotelList = res.data.hotelList;
                if ($this.hotelList && $this.hotelList.length > 0) {
                  $this.initMap(queryType);
                } else {
                  this.initEmpty();
                }
              } else {
                $this.hotelList = $this.hotelList.concat(res.data.hotelList);
                if (res.data.hotelList && res.data.hotelList.length > 0) {
                  $this.mapDisplay = true;
                  $this.initMap("add");
                }
              }
            }
            if ($this.totalNum === 0) {
              $this.noMore = true;
            } else {
              $this.noMore =
                $this.totalNum &&
                ($this.hotelList.length == $this.totalNum ? true : false);
            }
            $this.disabledRequest = !$this.noMore;
          } else {
            $this.disabledRequest = true;
            $this.wholeLoading = false;
            $this.confirmFlag = true;
            $this.confirmMsg =
              $this.$t("ERRORMESSAGE." + res.code) ===
              "ERRORMESSAGE." + res.code
                ? $this.$t("ERRORMESSAGE.NOTFOUND")
                : $this.$t("ERRORMESSAGE." + res.code);
            console.log(
              "获取房型下拉框数据 请求失败, code:" , res.code,
              res.message
            );
          }
        })
        .catch((e) => {
          $this.disabledRequest = true;
          $this.wholeLoading = false;
          $this.confirmFlag = true;
          $this.confirmMsg = $this.$t("ERRORMESSAGE." + e.mesCode);
          console.log("获取房型下拉框数据 请求失败", e.objError);
        });
    },
    arrayToObj(arr,posHotelTravelRuleDescFlag,posHotelTravelRuleDescCn,posHotelTravelRuleDescEn, currencySign) {
      let arrResult = [],
      strResult1 = "",
      strResult2 = "",
      strResult = "";
      if(this.$objBaseInfo.policySwitch && this.$objBaseInfo.personalizationPolicySwitch && this.$objBaseInfo.personalizationPolicyInfo){
        strResult = this.$i18n.locale == "en"?this.$objBaseInfo.personalizationPolicyInfo.descEn : this.$objBaseInfo.personalizationPolicyInfo.descCn;
         if(posHotelTravelRuleDescFlag)
        {
           strResult = this.$i18n.locale == "en"?posHotelTravelRuleDescEn : posHotelTravelRuleDescCn;
        }
      }else{
        if (arr.length == 0) {
          strResult = this.$t("RESULT.OUTOFPOLICYTIPEMPTY");
        } else {
          for (let obj in arr) {
            let objOutofPolicy = {};
            if (arr[obj]["key"] === "amountTopLimit") {
              objOutofPolicy.price = arr[obj]["value"];
              strResult1 = this.$t("RESULT.OUTOFPOLICYTIP1", {
                price: currencySign + objOutofPolicy.price,
              });
            } 
            if (arr[obj]["key"] === "NegotiationPrice") {
              // objOutofPolicy.star = arr[obj]["value"];
              // strResult2 = this.$t("RESULT.OUTOFPOLICYTIP2", {
              //   star: objOutofPolicy.star,
              // });
              strResult2 =  this.$t("RESULT.OUTOFPOLICYTIP3");
            }
          }

          strResult = strResult1 + (strResult1 === "" ? "" : "<br>") + strResult2;
        }
      }
      arrResult.push(strResult);
      return arrResult;
    },
    setPriceAffix: function () {
      let nodePrice = document.querySelectorAll(".price");
      if (nodePrice != null && nodePrice.length > 0) {
        for (let item in nodePrice) {
          if (parseFloat(item).toString() != "NaN") {
            if (this.$i18n.locale === "en") {
              nodePrice[item].setAttribute("data-content-after", "");
            } else {
              nodePrice[item].setAttribute("data-content-before", "");
            }
          }
        }
      }
    },
    // marker 点击跳转详情页
    transfer(data) {
      let localGeo = { latitude: "", longitude: "" };
      if (data.hotelDescriptiveInfo.location) {
        localGeo = data.hotelDescriptiveInfo.location.find((item) => {
          if (item.geoType == "gps") {
            return item;
          }
        });
      }
      this.wholeLoading = true;
      console.log(data, typeof data);
      // // 校验是否有房型信息
      let params = {
        posCode: this.objBaseInfo.poscode,
        hotelCode: data.hotelDescriptiveInfo.id.toString(),
        checkInDate: this.checkInDate
          ? this.checkInDate
          : this.searchInfo.checkInAt,
        checkOutDate: this.checkOutDate
          ? this.checkOutDate
          : this.searchInfo.checkOutAt,
        noGuests: this.roomNum,
        noRooms: this.guestNum,
        bookingContactId: this.objBaseInfo.loginID,
        source: this.objBaseInfo.sourceType, //请求来源OBT/CRM,供延时功能使用
        pageRequest: {
          page: 1,
          per_page: 10,
        },
        language: ["en-US", "zh-CN"],
        countryCode: this.objBaseInfo.countryCode, //国家ID
        cwtCityCode: this.searchInfo.city.cityCode, //城市id
        groupCode:data.hotelDescriptiveInfo.group,
      };
      if(Object.prototype.hasOwnProperty.call(this.objBaseInfo,"openResource"))
      {
        if(this.objBaseInfo.openResource!=undefined && this.objBaseInfo.openResource!="" && this.objBaseInfo.openResource!=null)
        {
          params.openResource=JSON.parse(this.objBaseInfo.openResource);
        }
      }
      let that = this;
      availabilityProperty(params)
        .then((res) => {
          if (res.code == 200) {
            that.wholeLoading = false;
            if (res.data.error.code != 0) {
              that.confirmFlag = true;
              that.confirmMsg =
                that.$t("ERRORMESSAGE." + res.data.error.code) ===
                "ERRORMESSAGE." + res.data.error.code
                  ? that.$t("ERRORMESSAGE.NOTFOUND")
                  : that.$t("ERRORMESSAGE." + res.data.error.code);
            } else {
              if (data.currencyCode) {
                that.objBaseInfo.defaultCurrencyCode = data.currencyCode;
                that.objBaseInfo.defaultCurrencySign =
                  that.$currencySign[that.objBaseInfo.defaultCurrencyCode];
              }
              //供房型页面使用
              that.$dictionaryData.Property = res;
              that.hotelCode = data.hotelDescriptiveInfo.id;
              that.chooseCode = that.cityInfo
                ? that.cityInfo
                : that.searchInfo.city.cityCode;
              that.checkIn = that.checkInDate
                ? that.checkInDate
                : that.searchInfo.checkInAt;
              that.checkOut = that.checkOutDate
                ? that.checkOutDate
                : that.searchInfo.checkOutAt;
              that.roomCount = that.roomNum
                ? that.roomNum
                : that.searchInfo.roomCount;
              that.guestCount = that.guestNum
                ? that.guestNum
                : that.searchInfo.guestCount;
              let detailParam = {
                paymentType: that.paymentType,
                checkInAt: that.checkIn,
                checkOutAt: that.checkOut,
                roomCount: that.roomCount,
                guestCount: that.guestCount,
                cwtCityCode: that.chooseCode,
                hotelcode: that.hotelCode,
                isAp: data.isAgencyPreferredHotel,
                isCp: data.isClientPreferredHotel,
                latitude: localGeo.latitude.toString(),
                longitude: localGeo.longitude.toString(),
                sourceType: that.objBaseInfo.sourceType,
                groupId:data.hotelDescriptiveInfo.group,
                cwtMark:data.hotelDescriptiveInfo.cwtMarkCode,
              };
              that.$router.push({
                name: "Detail",
                query: detailParam,
              });
            }
          } else {
            this.wholeLoading = false;
            that.confirmFlag = true;
            that.confirmMsg =
              that.$t("ERRORMESSAGE." + res.code) === "ERRORMESSAGE." + res.code
                ? that.$t("ERRORMESSAGE.NOTFOUND")
                : that.$t("ERRORMESSAGE." + res.code);
          }
        })
        .catch(function (error) {
          this.wholeLoading = false;
          that.confirmFlag = true;
          that.confirmMsg = that.$t("ERRORMESSAGE." + error.mesCode);
          console.log("获取房型下拉框数据 请求失败", error.objError);
        });
    },
    onHandleScroll(e) {
      let scrollTop = e.target.scrollTop;
      let scrollHeight = e.target.scrollHeight;
      let windowHeight = e.target.clientHeight;
      if (
        windowHeight + 5 >= scrollHeight - scrollTop &&
        this.disabledRequest && this.isScrollInit
      ) {
        this.disabledRequest = false;
        this.getHotelData("rolling");
        console.log("已经到达底部");
      }
    },
    // Show on List 跳转 result
    GoResult() {
      this.chooseCode = this.cityInfo
        ? this.cityInfo
        : this.searchInfo.city.cityCode;
      // this.chooseCode = this.cityInfo
      //   ? this.cityInfo
      //   : this.searchInfo.cwtCityCode;
      this.checkIn = this.checkInDate
        ? this.checkInDate
        : this.searchInfo.checkInAt;
      this.checkOut = this.checkOutDate
        ? this.checkOutDate
        : this.searchInfo.checkOutAt;
      this.roomCount = this.roomNum ? this.roomNum : this.searchInfo.roomCount;
      this.guestCount = this.guestNum
        ? this.guestNum
        : this.searchInfo.guestCount;
      this.searchInfo.city.cityCode = this.chooseCode;
      let mapParam = {
        checkInAt: this.checkIn,
        checkOutAt: this.checkOut,
        roomCount: this.roomCount,
        guestCount: this.guestCount,
        cwtCityCode: this.chooseCode,
        city: this.searchInfo.city,
        keyword: this.keyword,
        keywordType: this.keywordType,
        priceArea:this.priceArea,
        priceAreaValue:this.priceAreaValue,
        stars: this.stars,
        groupCode: this.groupCode,
        showStar: this.showstar,
        showPrice: this.show,
        radius: this.radiusValue,
      };
      this.$router.push({
        name: "Result",
        query: {
          searchParam: JSON.stringify(mapParam),
          sourceType: this.objBaseInfo.sourceType,
        },
      });
    },
    GoDetail(data) {
      if(data.type){
        data = data.target.extraData;
      }
      let localGeo = { latitude: "", longitude: "" };
      if (data.hotelDescriptiveInfo?.location) {
        localGeo = data.hotelDescriptiveInfo.location.find((item) => {
          if (item.geoType == "gps") {
            return item;
          }
        });
      }
      // 校验是否有房型信息
      let params = {
        posCode: this.objBaseInfo.poscode,
        hotelCode: data.hotelDescriptiveInfo.id.toString(),
        checkInDate: this.checkInDate
          ? this.checkInDate
          : this.searchInfo.checkInAt,
        checkOutDate: this.checkOutDate
          ? this.checkOutDate
          : this.searchInfo.checkOutAt,
        noGuests: this.roomNum,
        noRooms: this.guestNum,
        bookingContactId: this.objBaseInfo.loginID,
        source: this.objBaseInfo.sourceType, //请求来源OBT/CRM,供延时功能使用
        pageRequest: {
          page: 1,
          per_page: 10,
        },
        language: ["en-US", "zh-CN"],
        countryCode: this.objBaseInfo.countryCode, //国家ID
        cwtCityCode: this.searchInfo.city.cityCode, //城市id
        groupCode:data.hotelDescriptiveInfo.group,
      };
      if(Object.prototype.hasOwnProperty.call(this.objBaseInfo,"openResource"))
      {
        if(this.objBaseInfo.openResource!=undefined && this.objBaseInfo.openResource!="" && this.objBaseInfo.openResource!=null)
        {
          params.openResource=JSON.parse(this.objBaseInfo.openResource);
        }
      }
      this.wholeLoading = true;
      let that = this;
      availabilityProperty(params)
        .then((res) => {
          if (res.code == 200) {
            this.wholeLoading = false;
            if (res.data.error.code != 0) {
              that.confirmFlag = true;
              that.confirmMsg =
                that.$t("ERRORMESSAGE." + res.data.error.code) ===
                "ERRORMESSAGE." + res.data.error.code
                  ? that.$t("ERRORMESSAGE.NOTFOUND")
                  : that.$t("ERRORMESSAGE." + res.data.error.code);
              console.log(
                "获取房型下拉框数据 请求失败, code:" , res.data.error.code,
                res.data.error.message
              );
            } else {
              // 币种
              if (data.currencyCode) {
                that.objBaseInfo.defaultCurrencyCode = data.currencyCode;
                that.objBaseInfo.defaultCurrencySign =
                  that.$currencySign[that.objBaseInfo.defaultCurrencyCode];
              }
              //供房型页面使用
              that.$dictionaryData.Property = res;
              that.hotelCode = data.hotelDescriptiveInfo.id.toString();
              that.chooseCode = that.cityInfo
                ? that.cityInfo
                : that.searchInfo.city.cityCode;
              that.checkIn = that.checkInDate
                ? that.checkInDate
                : that.searchInfo.checkInAt;
              that.checkOut = that.checkOutDate
                ? that.checkOutDate
                : that.searchInfo.checkOutAt;
              that.roomCount = that.roomNum
                ? that.roomNum
                : that.searchInfo.roomCount;
              that.guestCount = that.guestNum
                ? that.guestNum
                : that.searchInfo.guestCount;
              let detailParam = {
                paymentType: that.paymentType,
                checkInAt: that.checkIn,
                checkOutAt: that.checkOut,
                roomCount: that.roomCount,
                guestCount: that.guestCount,
                cwtCityCode: that.chooseCode,
                cwtCountryCode:this.objBaseInfo.countryCode,
                hotelcode: that.hotelCode,
                isAp: data.isAgencyPreferredHotel,
                isCp: data.isClientPreferredHotel,
                latitude: localGeo.latitude.toString(),
                longitude: localGeo.longitude.toString(),
                sourceType: that.objBaseInfo.sourceType,
                groupId:data.hotelDescriptiveInfo.group,
                cwtMark:data.hotelDescriptiveInfo.cwtMarkCode,
              };
              if (that.$objBaseInfo.channelId == "MOBILE") {
                sessionStorage.setItem("mapData", JSON.stringify(data));
              }
              if(that.$objBaseInfo.sourceType == "OBT" && that.$objBaseInfo.channelId == "WEB"){
                this.openDetailPage(detailParam);
              }else{
                let message = {};
                message.hotelId = data.hotelDescriptiveInfo.id;
                window.parent.postMessage(message, "*");
                that.$router.push({
                  name: "Detail",
                  query: detailParam,
                });
              }
            }
          } else {
            this.wholeLoading = false;
            that.confirmFlag = true;
            that.confirmMsg =
              that.$t("ERRORMESSAGE." + res.code) === "ERRORMESSAGE." + res.code
                ? that.$t("ERRORMESSAGE.NOTFOUND")
                : that.$t("ERRORMESSAGE." + res.code);
            console.log(
              "获取房型下拉框数据 请求失败, code:" , res.code,
              res.message
            );
          }
        })
        .catch(function (error) {
          console.log(error);
          that.wholeLoading = false;
          that.confirmFlag = true;
          that.confirmMsg = that.$t("ERRORMESSAGE." + error.mesCode);
          console.log("获取房型下拉框数据 请求失败", error.objError);
        });
    },
    openDetailPage(detailParam) {
      const baseUrl = window.location.origin;
      const queryString = new URLSearchParams(detailParam).toString();
      const detailPath = `${process.env.BASE_URL || "/"}Detail?${queryString}`;
      const url = `${baseUrl}${detailPath}`;

      window.open(url, "_blank", "noopener,noreferrer");
    },
    initMap(type) {
      if (type !== "add") {
        const that = this;
        //创建地图实例
        this.map = new AMap.Map("container", {
          zoom: 11,
          center: [
            this.hotelList[0].hotelDescriptiveInfo.location[1].longitude,
            this.hotelList[0].hotelDescriptiveInfo.location[1].latitude,
          ],
          resizeEnable: true,
          lang: this.mapLanguage,
          viewMode: "2D", //默认使用 2D 模式
          showOversea: true, //开启世界地图
        });
        if(this.$objBaseInfo.sourceType != 'CRM'){
          AMap.plugin('AMap.Geolocation', function() {
            that.geolocation = new AMap.Geolocation({
                enableHighAccuracy: true,//是否使用高精度定位，默认:true
                timeout: 10000,          //超过10秒后停止定位，默认：5s
                position:'RT',    //定位按钮的停靠位置
                offset: [300, 5], //定位按钮与设置的停靠位置的偏移量，默认：[10, 20]
                zoomToAccuracy: false,   //定位成功后是否自动调整地图视野到定位点
                showCircle: false, // 是否显示定位精度圆
                showMarker: false, // 是否显示定位点
                panToLocation: false, // 定位成功后是否自动移动到响应位置
                needAddress:true,
            });
            that.map.addControl(that.geolocation);
            // 方式2：通过事件监听定位结果
            that.geolocation.on('complete', that.onLocationComplete);
          });
        }
      }
      if(this.$objBaseInfo.gaoDeCountryCode){
        this.geocoder = new AMap.Geocoder({city: this.$objBaseInfo.gaoDeCountryCode,});
      }else if(this.$objBaseInfo.gaoDeCityCode){
        this.geocoder = new AMap.Geocoder({city: this.$objBaseInfo.gaoDeCityCode,});
      }
      this.hotelList.slice().reverse().map((list) => {
        list.tagShow = false;
        this.handleOver(list, "ALL");
      });
      if(this.labelLongitude && this.labelLatitude){
        var circle = new AMap.Circle({
          center: [
            this.labelLongitude,
            this.labelLatitude
          ],
          radius: this.radius * 1000,
        });
        this.map.setFitView([circle]);
      } 
      if((this.tabName !=undefined && this.tabName == "third" && this.isAddTags) || this.isMapInit){
        let positions = [
          this.labelLongitude,
          this.labelLatitude
        ];
        let marker = new AMap.Marker({
          position: positions,
          icon: new AMap.Icon({
            image: require("@/icon/img/mark_bs.png"),
            imageSize: new AMap.Size(19,33),
          }),
          anchor:'bottom-center',
          offset: new AMap.Pixel(0, 0)
        });
        if(!this.isMapInit){
          marker.setLabel({
            direction:'top',
            content: `<div class="info">${this.$i18n.locale == "en" ? this.searchInfo.city.cityInfo.locationEnName : this.searchInfo.city.cityInfo.locationCnName}</div>`, //设置文本标注内容
          });
        }
        this.map.add(marker);
        this.map.setCenter(positions);
      }
    },
    onLocationComplete(result){
      if(result.info == "SUCCESS"){
        console.log("定位结果：", result);
        this.isAddTags = false;
        this.chosentags = [];
        this.keywordInput = {keyword: '', keywordType: ''};
        // if(this.$objBaseInfo.destinationType == 'I'){
        //   var countryCode = result.addressComponent.citycode;
        //   if(this.$objBaseInfo.gaoDeCountryCode != countryCode){
        //     this.geocoder = new AMap.Geocoder({city: "392000000",});  
        //     let searchparams = {
        //       params: {
        //         gaoDeCountryCode: "392000000",
        //       },
        //     };
        //     getcountryList(searchparams)
        //       .then((res) => {
        //         this.$objBaseInfo.countryCode = res.data.list[0].countryCode;
        //       }).then(()=>{
        //         this.getDistrict();
        //         this.popUpAnnouncement();
        //         this.searchHotHotel();
        //         this.address = result.formattedAddress;
        //         this.geoCode("onLocationComplete");
        //       });
        //   }
        // }
        if(this.$objBaseInfo.destinationType == 'D'){
          if(this.$objBaseInfo.gaoDeCityCode != result.addressComponent.citycode){
            this.geocoder = new AMap.Geocoder({city: result.addressComponent.citycode,});  
            getCityInfoByGaoDeCode(result.addressComponent.citycode).then((city) => {
              if (city) {
                this.cityInfo = this.searchInfo.city.cityCode = this.positionCityCode = city.cityCode;
              }
            }).then(()=>{
              this.getDistrict();
              this.popUpAnnouncement();
              this.searchHotHotel();
              this.address = result.formattedAddress;
              this.geoCode("onLocationComplete");
            });
          }else{
            this.address = result.formattedAddress;
            this.geoCode("onLocationComplete");
          }
        }else{
          this.address = result.formattedAddress;
          this.geoCode("onLocationComplete");
        }
       
      }
    },
    closeInfo() {
      this.hotelList.map((per) => {
        per.tagShow = false;
      });
      this.infoWindow.close();
      // 强制重新渲染组件
      this.$forceUpdate();
    },
    openInfo(e) {
      const list = e.target.extraData;
      list.tagShow = true;
      this.mapWinodwInfo(list);
      this.isScrollInit = false;
      document.querySelector("#nodePage" + list.hotelDescriptiveInfo.id).scrollIntoView({
        behavior: 'smooth',
      });
      this.$forceUpdate();
    },
    mapWinodwInfo(list) {
      //构建信息窗体中显示的内容
      let info = [];
      var hotelName = this.$i18n.locale === "en" ? list.hotelDescriptiveInfo.name["en"] : list.hotelDescriptiveInfo.name["zh-CN"];
      var currencySymbols = this.$i18n.locale === "en" ? 
      `From ${ (list.currencyCode ? this.$currencySign[list.currencyCode] : this.objBaseInfo.defaultCurrencySign) +  list.averagePrice}`: 
      `${ (list.currencyCode ? this.$currencySign[list.currencyCode] : this.objBaseInfo.defaultCurrencySign) +  list.averagePrice} 起`;

      info.push(`<div style="min-width:20rem;background-color:white;overflow:hidden;"><div style="padding:10px;"><div style="font-size:1.6rem;cursor:pointer;">${hotelName}</div><div style="display:flex;align-items:center;justify-content:space-between;margin-top:6px;"><div style="display:flex;align-items:center;">`);
      if(list.hotelDescriptiveInfo.standardStar > 0){
        let score = list.hotelDescriptiveInfo.standardStar;
        const starPath = "M313.6 924.48a70.4 70.4 0 0 1-74.152-5.365 70.4 70.4 0 0 1-27.992-68.875l37.888-220.928L88.96 472.96a70.4 70.4 0 0 1 3.788-104.225A70.4 70.4 0 0 1 128 352.896l221.76-32.256 99.2-200.96a70.4 70.4 0 0 1 100.246-28.595 70.4 70.4 0 0 1 25.962 28.595l99.2 200.96 221.824 32.256a70.4 70.4 0 0 1 39.04 120.064L774.72 629.376l37.888 220.928a70.4 70.4 0 0 1-102.144 74.24L512 820.096l-198.4 104.32z";
        const starSvg = (color) => `<svg viewBox="0 0 1024 1024" style="display:block;width:18px;height:18px;color:${color};"><path fill="currentColor" d="${starPath}"></path></svg>`;
        for (let i = 1; i <= 5; i++) {
          if (score >= i) {
            info.push(`<span style="display:inline-flex;margin-right:6px;">${starSvg("#F2A900")}</span>`);
          } else if (score > i - 1 && score < i) {
            info.push(`<span style="position:relative;display:inline-flex;width:18px;height:18px;margin-right:6px;">${starSvg("#C6D1DE")}<span style="position:absolute;top:0;left:0;width:50%;height:18px;overflow:hidden;">${starSvg("#F2A900")}</span></span>`);
          } else {
            info.push(`<span style="display:inline-flex;margin-right:6px;">${starSvg("#C6D1DE")}</span>`);
          }
            // info.push(` <svg class="svg-icon icon-star" style="height:1.5rem;width:1.5rem; float:left; padding-top:0.2rem; cursor:pointer">
            //                       <use xlink:href="#icon-star"></use></svg>`);
        }
      }else{
        let starScore = list.hotelDescriptiveInfo.starRating;
        for (let i = 1; i <= starScore; i++) {
          info.push(`<span><svg class="svg-icon" style="height: 13px;width:18px;vertical-align:middle;"><use xlink:href="#icon-hotel_icon_diamond"></use></svg></span>`);
        }
      }
      info.push(`</div>
          <div style="margin-left:12px;color:#FC6640;font-size:1.8rem;white-space:nowrap;cursor:pointer;">${currencySymbols}</div>
        </div></div></div>
      `);
      this.infoWindow = new AMap.InfoWindow({
        content: info.join(""), //使用默认信息窗体框样式，显示信息内容
        offset: new AMap.Pixel(0, -35),//设置信息窗体相对于标记位置偏移的像素值。
        isCustom: true,  //使用自定义窗体
      });

      this.infoWindow.open(this.map, [
        list.hotelDescriptiveInfo.location[1].longitude,
        list.hotelDescriptiveInfo.location[1].latitude,
      ]);
    },
    initEmpty() {
      this.map = new AMap.Map("container", {
        zoom: 2,
        center: [115.72, 41.6],
        resizeEnable: true,
      });
      this.positions = [115.72, 41.6];
      let marker = [];
      marker = new AMap.Marker({
        position: this.positions,
      });
      this.map.add(marker);
    },
    //tag展开收缩
    expand() {
      this.isActive = !this.isActive;
      this.showArrowDown = !this.showArrowDown;
      this.showArrow = !this.showArrow;
    },
    locationAdd(tab) {
      this.tabName = tab.name;
      if (this.tabName === "second") {
        this.showArrowDown = false;
        this.paneHeight = "pane-second";
        this.locationType = 2;
      } else if (this.tabName === "third") {
        this.showArrowDown = false;
        this.paneHeight = "pane-third";
        this.locationType = 3;
      } else {
        this.showArrowDown = false;
        this.paneHeight = "pane-first";
      }
      this.$nextTick(() => {
        this.height();
      });
    }, 
     // 树形菜单确认按钮
    onTreeConfirm(locationInfo) {
      this.isAddTags = false;
      this.isMapInit = false;
      let locationChose = {};
      if (this.treeActive == 0) {
        // 地区切换
        this.tabName = "first";
        if (this.areaRadio) {
          locationChose = this.choseArea;
          this.isAddTags = true;
        }
        this.radiusValue = null;
        this.customSelected = this.waySelected = "";
      } else if (this.treeActive == 1) {
        //机场/火车站
        this.tabName = "second";
        if (this.waySelected) {
          locationChose = this.choseWay;
          this.isAddTags = true;
        } else if(this.objBaseInfo.destinationType != 'I') {
          // 未选中机场火车站
          showToast(this.$t("RESULT.MOBILESELECTAIR"));
          return false;
        }
        this.radiusValue = this.distSelected;
        this.customSelected = this.areaRadio = "";
      } else if (this.treeActive == 2) {
        //自定义地标
        this.tabName = "third";
        if (this.customSelected) {
          locationChose = this.choseCustom;
          this.isAddTags = true;
        } else if(this.objBaseInfo.destinationType != 'I') {
          showToast(this.$t("RESULT.MOBILESELECTCUSTOMER"));
          // 未选中自定义坐标
          return false;
        }
        this.radiusValue = this.distSelected;
        this.waySelected = this.areaRadio = "";
      }
      //this.selectMenuActive = this.treeActive;
      //this.selectLocationCode = locationChose;
      if (locationChose != {} && locationChose.locationCode) {
        this.labelLongitude = locationChose.longitude;
        this.labelLatitude = locationChose.latitude;
        this.geoCodeType = locationChose.geoCodeType;
        this.locationCode = locationChose.locationCode;
        this.keywordInput = {keyword: locationChose.locationNameLists[this.$t("COMMONPARAM.RESPONSEDATA.SHOWTYPE")], keywordType: "auto"};
        //添加菜单选中颜色
        //this.titleActive = "location_active"; //location_active
      } else {
        this.keywordInput = {keyword: this.keyword, keywordType: "input"};
        this.labelLongitude = "";
        this.labelLatitude = "";
        this.geoCodeType = "";
        this.locationCode = "";
        this.selectLocationCode = {};
        // 清空菜单颜色
        //this.titleActive = "";
      }
      if (this.objBaseInfo.channelId == "WEB") {
        this.$refs.location.toggle(false);
      }
      
      //landmark处理
      if (this.tabName == "four") {
        this.isAddTags = true;
        this.radiusValue = 5;
        this.labelLongitude = locationInfo.longitude;
        this.labelLatitude = locationInfo.latitude;
        this.geoCodeType = locationInfo.geoCodeType;
        this.locationCode = locationInfo.locationCode;
        this.keywordInput = {keyword: locationInfo.locationNameLists[this.$t("COMMONPARAM.RESPONSEDATA.SHOWTYPE")], keywordType: "auto"};
      }
      if (this.distSelected && this.objBaseInfo.destinationType == "I") {
        this.radiusValue = this.distSelected;
      }
      this.getHotelData();
    },
    clearHandle(isClsoe, tabName, locationInfo) {
      if (this.objBaseInfo.channelId == "WEB") {
        this.haveAirports = false;
        this.haveCustoms = false;
        if (tabName == "second") {
          this.haveAirports = true;
        }
        if (tabName == "third") {
          this.haveCustoms = true;
        }
        this.tabName = tabName;
        this.activeName = tabName;
        this.locationAdd({ name: tabName });
        if (isClsoe) {
          this.handleClose();
        } else {
          this.addChosentags(locationInfo,false);
        }
      } else {
        switch (tabName) {
          case "first":
            this.treeActive = 0;
            this.areaRadio = locationInfo.locationCode;
            this.choseArea = locationInfo;
            break;
          case "second":
            this.treeActive = 1;
            this.waySelected = locationInfo.locationCode;
            this.choseWay = locationInfo;
            this.distSelected = 5;
            break;
          case "third":
            this.treeActive = 2;
            this.customSelected = locationInfo.locationCode;
            this.choseCustom = locationInfo;
            this.distSelected = 5;
            break;
          case "four":
            this.tabName = tabName;
            this.treeActive = 3;
            break;
        }
        this.onTreeConfirm(locationInfo);
      }
    },
    locationInfo(value) {
      this.wholeLLoading = false;
      this.wholeLoading = !(!this.wholeHLoading && !this.wholeLLoading);
      this.locationInformation = value;
      this.customlocationGet();
      this.airportGet();
      this.$nextTick(() => {
        this.height();
      });
    },
    height() {
      if (document.getElementById(this.paneHeight)) {
        this.scrollHeight = document.getElementById(this.paneHeight).scrollHeight;
      }
      let minHeight = 85;
      this.tagHeight = this.scrollHeight > minHeight ? minHeight : this.scrollHeight;
      if (this.scrollHeight > 85) {
        this.isActive = true;
        this.showArrow = true;
      } else {
        this.showArrow = false;
      }
    },
    airportGet() {
      this.locationType = 2;
      this.getLocationData(2);
    },
    customlocationGet() {
      this.locationType = 3;
      this.getLocationData(3);
    },
    getDistrict() {
      this.getLocationData(1);
    },
    async getLocationData(type) {
      let that = this;
      this.loading = true;
      try {
        this.chooseCode = this.cityInfo ? this.cityInfo : this.searchInfo.city.cityCode;
        let params = { params: { CityCode: this.chooseCode, LocationType: type, isEnable: 1 } };
        if (this.tabName == 'third' || type == 3) {
          params.params.customerCode = this.objBaseInfo.customerCode;
        }
        const res = await locationList(params);
        if (res.code == 200) {
          if (res.data.list && res.data.list.length > 0) {
            if (type == 2) {
              this.haveAirports = true;
              if (this.objBaseInfo.destinationType == "I") {
                this.activeName = "second";
              }
              this.airportslocationInfo = res.data.list;
            }
            if (type == 3) {
              this.haveCustoms = true;
              if (this.objBaseInfo.destinationType == "I") {
                this.activeName = "third";
              }
              this.customlocationInfo = res.data.list;
            }
            if(type ==  1){
              this.locationInfo(res.data.list);
            }
          } else {
            if (type == 2) {
              this.haveAirports = false;
              this.airportslocationInfo = [];
            }
            if (type == 3) {
              this.haveCustoms = false;
              this.customlocationInfo = [];
            }
          }
          this.loading = false;
          this.$nextTick(() => {
            this.height();
          });
          if (res.data.error.code != 0) {
            that.confirmFlag = true;
            that.confirmMsg = that.$t("ERRORMESSAGE." + res.data.error.code) === "ERRORMESSAGE." + res.data.error.code ? that.$t("ERRORMESSAGE.NOTFOUND") : that.$t("ERRORMESSAGE." + res.data.error.code);
          }
        } else {
          that.confirmFlag = true;
          that.confirmMsg = that.$t("ERRORMESSAGE." + res.code) === "ERRORMESSAGE." + res.code ? that.$t("ERRORMESSAGE.NOTFOUND") : that.$t("ERRORMESSAGE." + res.code);
        }

      } catch (e) {
        that.confirmFlag = true;
        that.confirmMsg = that.$t("ERRORMESSAGE.500");
        console.log("try-catch", e);
      }
    },
    handleClose(tag) {
      this.isAddTags = false;
      this.deleteTag = tag;
      this.chosentags.splice(this.chosentags.indexOf(tag), 1);
      this.keywordInput = {keyword: this.keyword, keywordType: "input"};
      if (tag === undefined) { //点击搜索按钮
        this.getHotelData("button");
      } else {
        this.searchInfo.city.cityInfo.locationName = "";
        this.searchInfo.city.cityInfo.locationCnName = "";
        this.searchInfo.city.cityInfo.locationCode = "";
        this.searchInfo.city.cityInfo.locationEnName = "";
        this.searchInfo.city.cityInfo.locationLatitude = "";
        this.searchInfo.city.cityInfo.locationLongitude = "";
        this.searchInfo.city.cityInfo.locationType = "";
        this.keywordType = "input";
        this.getHotelData();
      }
    },
    addChosentags(addlabel,isTab) {
      this.isMapInit = false;
      this.isAddTags = true;
      this.showstar = 3;
      this.show = 3;
      this.sortByPrice = null;
      this.sortByStarRating = null;
      let label = addlabel.locationNameLists;
      this.labelLongitude = addlabel.longitude;
      this.labelLatitude = addlabel.latitude;
      this.geoCodeType = addlabel.geoCodeType;
      if (this.chosentags.length == 0) {
        this.chosentags.push(label);
      } else {
        this.chosentags.splice(0, 1, label);
      }
      this.keywordInput = {keyword: label[this.$t("RESULT.RESPONSEDATA.locationNameLists")], keywordType: "auto"};
      this.keyword = "";
      this.locationCode = addlabel.locationCode;
      this.radiusValue = 5;
      if(isTab)
      {
        this.searchInfo.city.cityInfo.locationName = addlabel.locationNameLists;
        this.searchInfo.city.cityInfo.locationCnName = addlabel.locationName;
        this.searchInfo.city.cityInfo.locationCode = addlabel.locationCode;
        this.searchInfo.city.cityInfo.locationEnName = addlabel.locationNameLists.en;
        this.searchInfo.city.cityInfo.locationLatitude = addlabel.latitude;
        this.searchInfo.city.cityInfo.locationLongitude = addlabel.longitude;
        this.searchInfo.city.cityInfo.locationType = addlabel.locationType;
        this.keywordType = "auto";
      }
      this.getHotelData();
    },
    searchAnnouncementInfo(val){
      var cityInfo = this.searchInfo.city;
      let announcementParams = {
        params: {
          customerCode: this.objBaseInfo.customerCode,
          cityCode: cityInfo.cityCode,
          cityName:decodeURI(cityInfo.cityName),
          countryCode:cityInfo.cityInfo.countryCode,
          posCode:this.objBaseInfo.poscode,
          channelID: this.objBaseInfo.channelId,
          lang:this.$i18n.locale == "en"? this.$i18n.locale : "zh-CN"
        },
      };
      getAnnouncementInfo(announcementParams)
        .then((res) => {
          if (res.code == 200) {
            if(val == 1){
              this.hotelListNoticeDialogVisible = true;
            }
            this.objBaseInfo.announcementNotice = res.data.notice;
          }
        })
        .catch((err) => {
        });
    },
    //Announcement
    setAnnouncementFlag(value) {
      this.hotelListNoticeDialogVisible = value;
    },
    searchHotHotel(){
      var cityInfo = this.searchInfo.city;
      let hotHotelParams = {
        params: {
          cityCode: cityInfo.cityCode,
        },
      };
      gethothotel(hotHotelParams)
      .then((res) => {
        if (res.code == 200) {
          if(res.data && res.data.hotHotelList.length > 0){
            this.hotHotelInfo = res.data.hotHotelList;
            this.showHotHotel = true;
          }else{
            this.showHotHotel = false;
          }
        }else{
          this.showHotHotel = false;
        }
      })
      .catch((err) => {
        this.showHotHotel = false;
      });
    },
    choseHotHotel(val){
      this.keyword = val.hotelName[this.$t('RESULT.RESPONSEDATA.locationNameLists')];
      this.keywordInput = {keyword: this.keyword, keywordType: "input"};
      this.getHotelData();
    },
    popUpAnnouncement(){
      var uiAnnoucementSettings = this.objBaseInfo.uiAnnoucementSettings;
      if(uiAnnoucementSettings && uiAnnoucementSettings.length> 0){
        if(uiAnnoucementSettings[0].isPopUp && (sessionStorage.getItem("isFirstIntoResult")== "true"||this.isCityChange)){
          sessionStorage.setItem("isFirstIntoResult", false);
          this.searchAnnouncementInfo(1);
          // if (this.$i18n.locale == "en"){
          //   if(uiAnnoucementSettings[0].notice["en"].indexOf('}') >0){
          //     this.searchAnnouncementInfo(1);
          //   }else{
          //     this.hotelListNoticeDialogVisible = true;
          //     this.noticeTitle = uiAnnoucementSettings[0].title["en"];
          //     this.showHotelListNotice = uiAnnoucementSettings[0].isNavigationBarLabel;
          //   }
          // }else{
          //   if(uiAnnoucementSettings[0].notice["zh-CN"].indexOf('}') >0){
          //     this.searchAnnouncementInfo(1);
          //   }else{
          //     this.hotelListNoticeDialogVisible = true;
          //     this.noticeTitle = uiAnnoucementSettings[0].title["zh-CN"];
          //     this.showHotelListNotice = uiAnnoucementSettings[0].isNavigationBarLabel;
          //   }
          // }
        }else if(uiAnnoucementSettings[0].isNavigationBarLabel){
          this.searchAnnouncementInfo();
          if (this.$i18n.locale == "en"){
            this.noticeTitle = uiAnnoucementSettings[0].title["en"];
          }else{
            this.noticeTitle = uiAnnoucementSettings[0].title["zh-CN"];
          }
          this.showHotelListNotice = true;
        }else{
          this.showHotelListNotice = false;
        }
      }
    },
    checkpaymentType(cityInfo){
      if(this.objBaseInfo.openResource){
        var data = JSON.parse(this.objBaseInfo.openResource);
        this.isCorpPay = false;
        this.isHotelPay = false;
        this.isPrepay = false;
        if(this.objBaseInfo.destinationType === "I" && data.International.includes("3")){//国际是否开启公付
          this.isCorpPay = true;
        }else if (this.objBaseInfo.destinationType === "I" && data.International.includes("1")){//国际是否开启现付
          this.isHotelPay = true;
        }else if (this.objBaseInfo.destinationType === "I" && data.International.includes("2")){//国际是否开启预付
          this.isPrepay = true;
        }
        if (cityInfo && cityInfo != {} && this.objBaseInfo.destinationType === "D") {
          if(isCityGAT(cityInfo.provinceCode)){
            if(data.GangAoTai.includes("3")){//港澳台是否开启公付
              this.isCorpPay = true;
            }
            if(data.GangAoTai.includes("1")){//港澳台是否开启现付
              this.isHotelPay = true;
            }
            if(data.GangAoTai.includes("2")){//港澳台是否开启预付
              this.isPrepay = true;
            }
          }else{
            if(data.Domestic.includes("3")){//大陆是否开启公付
              this.isCorpPay = true;
            }
            if(data.Domestic.includes("1")){//大陆是否开启现付
              this.isHotelPay = true;
            }
            if(data.Domestic.includes("2")){//大陆是否开启预付
              this.isPrepay = true;
            }
          }
        } 
      }
    },
    updateSearchData() {
      if (this.searchInfo.priceArea) {
        [this.priceArea, this.searchInfo.priceArea] = [this.searchInfo.priceArea, ''];
        this.priceAreaValue = this.searchInfo.priceAreaValue;
      }
      if (this.searchInfo.stars) {
        [this.stars, this.searchInfo.stars] = [this.searchInfo.stars, ''];
        this.originalStarSelect = this.stars;
      }
      if (this.searchInfo.groupCode) {
        [this.groupCode, this.searchInfo.groupCode] = [this.searchInfo.groupCode, ''];
      }
      if (this.searchInfo.paymentType) {
        [this.paymentType, this.searchInfo.paymentType] = [this.searchInfo.paymentType, ''];
      }
      if (this.searchInfo.showStar && this.searchInfo.showStar != 3) {
        [this.showstar, this.searchInfo.showStar] = [this.searchInfo.showStar, ''];
        this.sortByPrice = null;
        this.sortByStarRating = !this.sortByStarRating;
      }
      if (this.searchInfo.showPrice && this.searchInfo.showPrice != 3) {
        [this.show, this.searchInfo.showPrice] = [this.searchInfo.showPrice, ''];
        this.sortByStarRating = null;
        this.sortByPrice = !this.sortByPrice;
      }
      if (this.searchInfo.radius) {
        [this.radiusValue, this.searchInfo.radius] = [this.searchInfo.radius, ''];
      }else{
        this.radiusValue = 30;
      }
    },
    handlePriceRangeChange(type){
      switch (type) {
        case 2:
          this.priceArea = "0,300";
          break;
        case 3:
          this.priceArea = "300,500";
          break;
        case 4:
          this.priceArea = "500,1000";
          break;
        case 5:
          this.priceArea = "1000";
          break;
        case 6:
          this.showCustomizePriceRange = true;
          break;
        default:
          this.priceArea = "";
          break;
      }
      if(type!=6){
        this.getHotelData("price");
      }
    },
    clearNoNumPriceRangeFrom(){
      this.priceRangeFrom = this.priceRangeFrom.replace(/[^\d.]/g, "");  //清除“数字”和“.”以外的字符
      this.priceRangeFrom = this.priceRangeFrom.replace(/\.{2,}/g, "."); //只保留第一个. 清除多余的
      this.priceRangeFrom = this.priceRangeFrom.replace(".", "$#$").replace(/\./g, "").replace("$#$", ".");
      this.priceRangeFrom = this.priceRangeFrom.replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3');//只能输入两个小数
      this.priceRangeFrom = this.priceRangeFrom.replace(/^0+\./g, '0.').replace(/^0+([0-9])/, '$1');  //清除.前面无效的0
      if (this.priceRangeFrom.indexOf(".") < 0 && this.priceRangeFrom != "") {//以上已经过滤，此处控制的是如果没有小数点，首位不能为类似于 01、02的金额
        this.priceRangeFrom = parseFloat(this.priceRangeFrom);
      }
    },
    clearNoNumPriceRangeTo(){
      this.priceRangeTo = this.priceRangeTo.replace(/[^\d.]/g, "");  //清除“数字”和“.”以外的字符
      this.priceRangeTo = this.priceRangeTo.replace(/\.{2,}/g, "."); //只保留第一个. 清除多余的
      this.priceRangeTo = this.priceRangeTo.replace(".", "$#$").replace(/\./g, "").replace("$#$", ".");
      this.priceRangeTo = this.priceRangeTo.replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3');//只能输入两个小数
      this.priceRangeTo = this.priceRangeTo.replace(/^0+\./g, '0.').replace(/^0+([0-9])/, '$1');  //清除.前面无效的0
      if (this.priceRangeTo.indexOf(".") < 0 && this.priceRangeTo != "") {//以上已经过滤，此处控制的是如果没有小数点，首位不能为类似于 01、02的金额
        this.priceRangeTo = parseFloat(this.priceRangeTo);
      }
    },
    searchHotelForPriceRange(){
      if (this.priceRangeTo != "" && this.priceRangeFrom != ""){
        this.priceArea = this.priceRangeFrom + "," + this.priceRangeTo;
        this.priceAreaValue = this.priceArea.replace(",", "-");
      } else if (this.priceRangeTo == "" && this.priceRangeFrom == ""){
        this.priceArea = "";
        this.priceAreaValue = this.priceArea;
      }else if (this.priceRangeTo == ""){
        this.priceArea = this.priceRangeFrom.toString();
        this.priceAreaValue = this.$t("RESULT.PRICERANGE7", {
          priceRange: this.priceArea,
          });
        this.priceRangeTitle = this.$t("RESULT.PRICERANGE7", {
          priceRange: this.priceArea,
          });
      }else{
        this.priceArea =  "0," + this.priceRangeTo;
        this.priceAreaValue = this.priceArea.replace(",", "-");
      }
      
      this.showCustomizePriceRange = false;
      this.getHotelData();
    },
    handleStarChange(visible){
      if (!visible) {
        if(JSON.stringify(this.stars) != JSON.stringify(this.originalStarSelect)){
          this.getHotelData();
        }
      }
    },
    policyDescriptions() {
      return (item) => {
        const currencySign = item.currencyCode
          ? this.$currencySign[item.currencyCode]
          : this.objBaseInfo.defaultCurrencySign;
          let arrResult = [],
        strResult1 = "",
        strResult2 = "",
        strResult = "";
        var arr = item.outOfPoliyDescriptions;
        if(this.$objBaseInfo.policySwitch && this.$objBaseInfo.personalizationPolicySwitch && this.$objBaseInfo.personalizationPolicyInfo && this.$objBaseInfo.personalizationPolicyInfo.descCn){
          strResult = this.$i18n.locale == "en"?this.$objBaseInfo.personalizationPolicyInfo.descEn : this.$objBaseInfo.personalizationPolicyInfo.descCn;
          if(item.posHotelTravelRuleDescFlag)
          {
             strResult = this.$i18n.locale == "en"?item.posHotelTravelRuleDescEn : item.posHotelTravelRuleDescCn;
          }
        }else{
          if (arr.length == 0) {
            strResult = this.$t("RESULT.OUTOFPOLICYTIPEMPTY");
          } else {
            for (let obj in arr) {
              let objOutofPolicy = {};
              if (arr[obj]["key"] === "amountTopLimit") {
                objOutofPolicy.price = arr[obj]["value"];
                strResult1 = this.$t("RESULT.OUTOFPOLICYTIP1", {
                  price: currencySign + objOutofPolicy.price,
                });
              } 
              if (arr[obj]["key"] === "NegotiationPrice") {
                strResult2 =  this.$t("RESULT.OUTOFPOLICYTIP3");
              }
            }
            strResult = strResult1 + (strResult1 === "" ? "" : "\n") + strResult2;
          }
        }
        arrResult.push(strResult);
        return arrResult;
      };
    },
  },
};
</script>
<style scoped>
@media screen and (min-width: 961px) {
  .showmoreContent {
    /*margin-top: 2.1rem;*/
    margin-bottom: 4.2rem;
    height: 3rem;
  }
  .noMore {
    text-align: center;
    background-color: #e7e9ea;
    margin-top: 0.5rem;
    height: 2rem;
    font-size: 1.4rem;
    font-family: sans-serif;
    line-height: 2rem;
  }
  tab_active {
    width: 100%;
    height: 0;
    padding-top: 100%;
    opacity: 1;
    background: yellow;
  }
  tab_default {
    width: 100%;
    height: 0;
    padding-top: 100%;
    opacity: 1;
  }
  .pricePolicy {
    width: 20rem;
    height: 3rem;
    font-size: 1.4rem;
    color: #f2a900;
    margin-top: 0.5rem;
  }
  .div_result ::-webkit-scrollbar {
    width: 0.6rem;

    background-color: #f5f5f5;
  }

  ::-webkit-scrollbar-thumb {
    border-radius: 1;
    background-color: #fc6640;
  }

  .leftPart {
    height: 70rem;
    overflow-y: auto;
  }
  .HOTEL {
    width: 10rem;
    height: 2.3rem;
    line-height: 2.3rem;
    background: #f2a900;
    text-align: center;
    font-size: 1.2rem;
    font-family: PingFang SC;
    /*font-weight: 600;*/
    border-radius: 10%;
  }
  .boxContent {
    width: 30rem;
  }
  .boxTitle {
    width: 28rem;
    height: 4.4rem;
    font-size: 1.6rem;
    color: #333f48;
  }
  .starPoint {
    padding-top: 4rem;
    float: left;
    width: 12rem;
    height: 1.5rem;
    font-size: 0.2rem;
  }
  .boxPrice {
    width: 3.6rem;
    height: 2.2rem;
    margin-right: 2rem;
    padding-top: 4rem;
    float: right;
    color: #fc6640;
    font-size: 1.6rem;
    margin-left: 1rem;
  }
  .boxAbove {
    float: right;
    width: 4.6rem;
    height: 2.2rem;
    padding-top: 4rem;
    margin-left: 2rem;
    color: #fc6640;
    font-size: 1.6rem;
  }
  /*去掉el-tab-pane底部灰色线条*/
  .deleteBorder .el-tabs__nav-wrap::after {
    height: 0;
  }
  ::v-deep .grid-content .el-input__inner{
    height: 30px;
  }
  ::v-deep .grid-content .el-input__icon{
    line-height: 30px;
  }
  ::v-deep .el-select{
    width: 70%!important;
  }
  .address_info{
    font-family: 'Source Sans Pro';
    color: #838A90;
  }
}
</style>
<style lang="stylus" scoped>
@media screen and (min-width: 961px) {
  .div_search_result {
    font-size: 1.4rem;
    line-height: 2rem;
    margin-bottom: 1.3rem;
  }

  .div_select_bar {
    display: flex;
    background-color: #fff;
    justify-content: space-between;
    font-size: 1.4rem;
  }

  .div_select_nav {
    display: flex;
    font-size: 1.4rem;

    .div_select_item {
      padding: 1rem 1.6rem;
      cursor: pointer;

      &.active {
        color: $link-tab-color;
        cursor: pointer;

        i::before {
          content: '\e78f';
        }
      }
    }
  }

  .span_select_text {
    margin-right: 0.5rem;
  }

  .div_select_loc {
    margin: 0.8rem 1.7rem;
  }

  .link_location {
    display: inline;
    float: left;
    padding-top: 0.2rem;
  }

  .div_result {
    margin-top: 1.3rem;
    display: flex;

    .div_result_l {
      height: 70rem;
      width: 50rem;
      margin-right: 1.3rem;
      overflow-y: auto;
    }

    .div_result_r {
      flex: 1;
      overflow: hidden;
    }
  }

  .div_result_imgs {
    margin-bottom: 1rem;
    color: #000;
    font-size: 1.4rem;
  }

  .div_result_img_f {
    position: relative;
    max-width: 50rem;
    max-height: fit-content;
    overflow: hidden;
  }

  .div_result_bg {
    width: 100%;
    height: 0;
    padding-top: 35%;
    opacity: 1;
  }

  .float_hotel_info {
    // height:40rem;
    position: absolute;
    top: 0;
    left: 0;
    padding: 0.3rem 1.3rem 0 1.3rem;
    width: 100%;
    cursor: pointer;
  }

  .hotel_title {
    font-size: 1.8rem;
    margin-bottom: 0.3rem;
    margin-top: 1rem;
    font-weight: 600;
    font-family: 'Sources Sans Pro';
    color: #222A30;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  .hotel_middle {
    // display: flex;
    justify-content: base-convert;

    .hotel_middle_l {
      display: flex;
      flex-direction: column;

      .hotel_middle_l_item {
        // margin-bottom: 1.3rem;
        span:not(:last-child) {
          margin-right: 1rem;
        }
      }

      svg.icon-star {
        padding-right: 0;
        width: 1.4rem;
        height: 1.4rem;
      }
    }
  }

  .hotel_icons {
    width: 25rem;
    display: flex;
    justify-content: space-around;
    margin-top: 1.3rem;
    bottom: 0;

    svg {
      margin-right: 1rem;
    }
  }

  .map_area {
    width: 100%;
    height: 100%;
  }

  span.price:before {
    content: attr(data-content-before);
    // padding-right: 1rem;
    font-size: 1.4rem;
  }

  span.price:after {
    content: attr(data-content-after);
    font-size: 1.5rem;
  }

  span.price {
    content: attr(data-content);
  }

  .policy_outof_in {
    margin: 0;
  }

  .grid-content {
    min-height: 5rem;
  }
  .center_style {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .red_color {
    color: red;
  }

  .commen_font {
    height: 2rem;
    font-size: 1.4rem;
    font-family: PingFang SC;
    font-weight: 600;
    color: #333f48;
    line-height: 2rem;
    cursor: pointer;
  }

  .commen_font:hover {
    color: #0a3d80;
  }

  .icon-star {
    font-size: 1rem;
  }

  .priceBottom {
    padding-top: 50%;
    font-size: 1.9rem;
    float: right; 
    margin-right: 4rem
  }
  .tag_height {
    height: 7.5rem;
    transition: min-height 2s linear;
    -webkit-transition: height 2s linear;
    overflow: hidden;
    
  }
  .icon_tags {
    cursor: pointer;
    margin-right: 1rem;
    margin-bottom: 1rem;
    height: 3rem;
    font-size: 1.4rem;
    font-family: sans-serif;
    color: #333f48 !important;
    border-radius: 0;
    background-color: #e7e9ea !important;
    padding: 0 10px;
    border-style: solid;
  }
 .fontstyle {
    height: 2rem;
    font-size: 1.4rem;
    font-family: sans-serif;
    /*font-weight: 600;*/
    color: #333f48;
    margin-left: 10px;
  }
  .tag_sty {
    height: 3rem !important;
    border-radius: 1.8rem !important;
    border: 0.1rem solid #333f48 !important;
    margin-left: 1rem !important;
    color: #333f48 !important;
    padding: 0 10px;
  }
  .location_area_bg {
    margin-top: 1rem;
    background-color: white;
    margin-left: 0;
    margin-right: 0;
  }
  .homeMain .el-tabs__item {
    line-height: 2rem;
    height: 2rem;
    font-size: 1.4rem;
    font-family: sans-serif;
    font-weight: 600;
    color: #333f48;
  }
  .deleteBorder::after {
    height: 0;
  }
  ::v-deep .amap-marker-label{
    font-size: 20px;
    line-height: 20px;
    border: none;
  }
  .input-card {
    position: absolute;
    top: -20px;
    right: -20px;
    z-index: 1000; 
    max-width: calc(100% - 32px); /* 响应式，确保不超出容器 */
    padding: 20px;
  }
  .map-search-card :deep(.el-input__wrapper) {
    min-height: 32px;
    height: 32px;
    align-items: center;
  }
  .map-search-card :deep(.el-input__prefix) {
    display: inline-flex;
    align-items: center;
    height: 100%;
  }
  .map-search-card :deep(.hotel_input__icon) {
    width: 20px;
    height: 16px;
    line-height: 16px;
    cursor: pointer;
  }
  .ellipsis-2-lines {
    display: -webkit-box;
    -webkit-line-clamp: 2; /* 限制显示行数 */
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .payment{
    width: 13rem!important;
    min-width: 13rem!important;
    font-size: 1.4rem;
  }
  .div_select_bar .payment :deep(.el-input__inner) {
    overflow: visible;
    text-overflow: clip;
    white-space: nowrap;
  }

  .div_select_bar .payment :deep(.el-select__selected-item),
  .div_select_bar .payment :deep(.el-select__placeholder),
  .div_select_bar .payment :deep(.el-select__tags-text) {
    overflow: visible;
    text-overflow: clip;
    white-space: nowrap;
  }

  .div_select_bar .payment :deep(.el-select__selection) {
    min-width: max-content;
  }
}
</style>